import store from '../store';
import { productTypes } from '@/constants/constants';

export default function multiplyTestSpeedPrice(products) {
  if (!products || products.length === 0) {
    return [];
  }

  const multiplier = store.getters.CART_DIAGNOSTIC_PRODUCTS.filter(
    (product) => product.enableSpeedTest,
  ).length || 1;

  return products.map(
    (product) => (product.entryType === productTypes.DEFAULT_TYPE
    || product.isSimpleTest ? product : {
        ...product,
        cost: product?.initialPrices.cost && product.initialPrices.cost > 0
          ? product.initialPrices.cost * multiplier : 0,
      }),
  );
}
